import { HouseIllustration } from '../types';

export const houseIllustrations: HouseIllustration[] = [
  {
    id: 'comprehensive-waterproofing',
    name: 'Complete Flexcrete Applications',
    description: 'Comprehensive waterproofing solutions for all areas of your home',
    imagePath: '/assets/waterarmor1.png',
    hotspots: [
      // Chimney Hotspot - On chimney (not too high)
      {
        id: 'chimney-flashing',
        x: 62.0,
        y: 11.5,
        title: 'Chimney Flashing',
        description: 'Critical waterproofing at chimney and roof junction',
        issue: 'Water intrusion at chimney base, leaks around chimney flashing, moisture damage to roof structure, potential fire hazards from water damage.',
        solution: 'Apply Flexcrete flashing around chimney base and roof junction. Prevents water infiltration at critical transition points. Essential for protecting roof structure and preventing leaks.',
        productLink: '/products/flashing',
        videoLink: '/videos/chimney-flashing'
      },
      
      // Roof Applications - Combined roof hotspot on main pitched roof
      {
        id: 'roof-applications',
        x: 52.0,
        y: 14.0,
        title: 'Roof Applications',
        description: 'Complete roof waterproofing for all roof types',
        issue: 'Roof leaks, cracked tiles, rusted panels, deteriorating shingles, ponding water, membrane failures, UV damage.',
        solution: 'Apply Flexcrete to repair and waterproof all roof types. UV resistant formula protects against sun damage. Repair cracked tiles, seal roof surface, and create waterproof membrane. Perfect for both pitched and flat roof applications.',
        productLink: '/products/applying',
        videoLink: '/videos/roof-waterproofing'
      },
      
      // Balcony & Catwalks - Left side upper level with railings
      {
        id: 'balcony',
        x: 26.8,
        y: 31.8,
        title: 'Balconies & Catwalks',
        description: 'Complete balcony waterproofing and flashing',
        issue: 'Water penetration at wall-balcony joints, moisture migration loosening tile bonds, balcony cracks, poor drainage.',
        solution: 'Use Flexcrete for flashing wall-balcony cold joints (highly recommended). Seal entire balcony from moisture intrusion including bottom side. Repair cracks and create proper pitch to divert water away from wall.',
        productLink: '/products/flashing',
        videoLink: '/videos/balcony-waterproofing'
      },
      
      // Exterior Facades - On exterior wall upper story
      {
        id: 'facades',
        x: 58.0,
        y: 28.0,
        title: 'Exterior Facades',
        description: 'Protective waterproof membrane for exterior walls',
        issue: 'Moisture intrusion through facades, poor stucco adherence, water damage to exterior walls, efflorescence.',
        solution: 'Spray Flexcrete protective waterproof membrane on exterior façade to prevent moisture intrusion and increase stucco adherence. Provides better substrate for cementitious façade coverings.',
        productLink: '/products/applying',
        videoLink: '/videos/facade-waterproofing'
      },
      
      // Bathroom & Shower - Right addition interior (visible through cutaway)
      {
        id: 'bathroom',
        x: 66.6,
        y: 41.3,
        title: 'Bathroom Shower Pans',
        description: 'Complete bathroom waterproofing',
        issue: 'Water leakage from shower pans, moisture escaping bathroom enclosure, structural damage, mold growth.',
        solution: 'Use Flexcrete to keep water inside shower pans and insulate water moisture from escaping bathroom enclosure. Creates perfect substrate for tile.',
        productLink: '/products/applying',
        videoLink: '/videos/bathroom-waterproofing'
      },
      
      // Planters - Left front planter box
      {
        id: 'planters',
        x: 15.6,
        y: 43.5,
        title: 'Planters',
        description: 'Waterproof interior of planters',
        issue: 'Water leakage from planters, stains, efflorescence deposits, structural damage.',
        solution: 'Waterproof interior of planters with Flexcrete to keep water inside and prevent stains and efflorescence deposits.',
        productLink: '/products/applying',
        videoLink: '/videos/planter-waterproofing'
      },
      
      // Retaining Walls - Moved to bed area in basement
      {
        id: 'retaining-walls',
        x: 42.0,
        y: 64.0,
        title: 'Retaining Walls',
        description: 'Protect retaining walls from water intrusion',
        issue: 'Water intrusion from behind walls, unsightly efflorescence deposits, damage to wall coverings.',
        solution: 'Apply Flexcrete to prevent moisture and water intrusion from behind retaining walls. Prevents unsightly efflorescence deposits and protects covering materials.',
        productLink: '/products/applying',
        videoLink: '/videos/retaining-wall-waterproofing'
      },
      
      // Foundation Walls - Close to foundation wall structure
      {
        id: 'foundation-walls',
        x: 19.0,
        y: 62.0,
        title: 'Foundation Walls',
        description: 'Below-grade foundation waterproofing',
        issue: 'Water infiltration through foundation walls, hydrostatic pressure, structural damage.',
        solution: 'Apply Flexcrete to foundation walls for protection against water intrusion. Works on both positive and negative water pressure.',
        productLink: '/products/applying',
        videoLink: '/videos/foundation-waterproofing'
      },
      
      // Cisterns & Tanks - In basement left area (visible tank)
      {
        id: 'cisterns-tanks',
        x: 18.0,
        y: 55.3,
        title: 'Cisterns & Holding Tanks',
        description: 'Waterproof concrete holding tanks and storage systems',
        issue: 'Tank leaks, water loss, corrosion from RO water, structural damage to concrete tanks.',
        solution: 'Apply Flexcrete interior waterproof lining to concrete holding tanks. Provides barrier resistant to RO water corrosive effects and ensures truly waterproof storage.',
        productLink: '/products/applying',
        videoLink: '/videos/tank-waterproofing'
      },
      
      // Basement Living Space - Underground center area
      {
        id: 'basement',
        x: 33.4,
        y: 56.6,
        title: 'Basement Walls',
        description: 'Protect interior walls from moisture intrusion and stains',
        issue: 'Basement flooding, water seepage through walls, damp conditions, cracks in basement walls, water intrusion around window frames.',
        solution: 'Apply Flexcrete to basement walls to prevent moisture intrusion, repair cracks, and seal window frames from water intrusion. Provides complete protection against damp conditions.',
        productLink: '/products/applying',
        videoLink: '/videos/basement-waterproofing'
      },
      
      // Fountain - Center yard circular fountain
      {
        id: 'fountain',
        x: 63.8,
        y: 55.9,
        title: 'Water Features & Fountains',
        description: 'Waterproof decorative water features',
        issue: 'Water spillover, leaks, unsightly efflorescence deposits, water loss.',
        solution: 'Use Flexcrete to keep water inside features and prevent spillover. Prevents unsightly efflorescence deposits and maintains water containment.',
        productLink: '/products/applying',
        videoLink: '/videos/water-feature-waterproofing'
      },
      
      // Deck & Terrace - On deck surface, moved right to avoid planter overlap
      {
        id: 'decks-terraces',
        x: 45.0, // Increased x value to keep more on right
        y: 50.0,
        title: 'Decks, Terraces & Patios',
        description: 'Slab waterproofing and surface protection',
        issue: 'Moisture penetration into slabs, deck cracks, poor substrate for coverings, water damage.',
        solution: 'Apply Flexcrete to prevent moisture and water penetration into slabs. Repair cracks and provide better substrate for tile, cement, or other deck coverings.',
        productLink: '/products/applying',
        videoLink: '/videos/deck-waterproofing'
      },
      
      // Spa & Hot Tub - Circular spa right side of pool
      {
        id: 'spas',
        x: 67.3,
        y: 72.5,
        title: 'Spas & Hot Tubs',
        description: 'Complete spa waterproofing system',
        issue: 'Spa leaks, efflorescence behind tile, cracks in spa structure, leaks around fittings.',
        solution: 'Apply Flexcrete to waterproof entire inside of spa. Highly recommended to waterproof behind tile line to avoid efflorescence deposits. Repair leaks around spa fittings and cracks.',
        productLink: '/products/applying',
        videoLink: '/videos/spa-waterproofing'
      },
      
      // Swimming Pool - Large rectangular pool in foreground
      {
        id: 'swimming-pool',
        x: 45.4,
        y: 68.8,
        title: 'Swimming Pools',
        description: 'Complete pool waterproofing system',
        issue: 'Pool leaks, efflorescence behind tile, cracks in pool structure, leaks around fittings.',
        solution: 'Apply Flexcrete to waterproof entire inside of pool. Highly recommended to waterproof behind tile line to avoid efflorescence deposits. Repair leaks around pool fittings and cracks.',
        productLink: '/products/applying',
        videoLink: '/videos/pool-waterproofing'
      },
      
    ]
  }
];
